// Typelizer digest 14cccc7fc6cae7bd323b0967cf550ddd
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /c/:company_id/bank_accounts */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/bank_accounts', {}, options),
    method: 'get',
  }),

  /** GET /c/:company_id/bank_accounts/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/bank_accounts/:id', params, options),
    method: 'get',
  }),
}
